/**
 * Wortweise UND-Suche (Spec docs/superpowers/specs/2026-07-29-syntax-search-and-design.md §3.4):
 * Der Suchbegriff wird in Wörter zerlegt, jedes Wort muss im Ziel vorkommen — Reihenfolge egal.
 * Ausdrücke in Anführungszeichen bleiben ein zusammenhängendes „Wort".
 * Serverseitiges Gegenstück: splitSearchWords in backend/searchSyntax.ts.
 */

export function splitSearchWords(term) {
  if (!term) return [];
  const tokens = term.match(/"[^"]+"|\S+/g) || [];
  return tokens
    .map((t) => (t.startsWith('"') && t.endsWith('"') && t.length >= 2 ? t.slice(1, -1) : t))
    .map((t) => t.trim().toLowerCase())
    .filter((t) => t !== '');
}

export function textContainsAllWords(text, words) {
  if (words.length === 0) return true;
  const haystack = (text || '').toLowerCase();
  return words.every((word) => haystack.includes(word));
}
